import { SmoothScroll } from "../components/SmoothScroll";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { CoverageMap } from "../components/CoverageMap";
import { QuoteSection } from "../components/QuoteSection";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";

export default function LandingPage() {
  return (
    <SmoothScroll>
      <div data-testid="landing-page" className="bg-coal-900 text-white">
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Services />
          <Portfolio />
          <CoverageMap />
          <QuoteSection />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </SmoothScroll>
  );
}
